import type { BoothDeckConfig } from '../_booth-base/types';

export const DATA_AI_CONFIG: BoothDeckConfig = {
  slug: 'data-ai-summit-booth',
  titleEyebrow: 'Data + AI Summit · San Francisco · June 2026 · Booth',
  context: 'Data + AI Summit · San Francisco 2026',
  description:
    'StreamNative booth deck for Data + AI Summit 2026 — Lakestream Platform, Ursa for Kafka (UFK), VLDB 2025 + 95% TCO proof, Nimble Robotics case study, $1,000 promo (Lakestream1000).',
  // Data + AI Summit 2026 runs Mon 15 – Thu 18 June, San Francisco.
  // Source: https://www.databricks.com/dataaisummit
  eventDate: '2026-06-15',
  promo: {
    eyebrow: 'Data + AI Summit · Lakestream Launch Promo',
    amount: '$1,000',
    code: 'Lakestream1000',
    // One-week window from the event's first day (mirrors the London promo).
    validity: 'Monday 15 June 2026 through Monday 22 June 2026 (UTC)',
    signupUrl: 'https://console.streamnative.cloud/signup?from=event_data-ai-summit-2026',
    signupDisplayUrl: 'console.streamnative.cloud/signup',
  },
};
